import { Element } from 'slate';
import { BlockElement } from '../../types';

export const blockQuoteType = 'blockquote';

// type guard
export const isBlockQuoteElement = (
  element?: Element
): element is BlockElement => element?.type === blockQuoteType;
